'use strict';

var pageWidget2Module = angular.module('t2g.pageWidget2', [
    'gettext',
    'ui.router',
    'ngSanitize',
    require('t2g.common.services.notificationService').name
]);

module.exports = pageWidget2Module;

pageWidget2Module.controller('PageWidget2Ctrl', require('./pageWidget2Ctrl'));

pageWidget2Module.config(function($stateProvider) {
    $stateProvider
        .state('private.main.pageWidget2', {
            url: '/page-widget-2',
            title: 'Booking widget website',
            templateUrl: 'https://cdn.termin2go.com/app/app/modules/pageWidget2/PageWidget2View.html?v=3.94.3',
            controller: 'PageWidget2Ctrl as PageWidget2Ctrl',
            resolve: {
                office: function(OfficeDA) {
                    return OfficeDA.get();
                }
            }
        });
});
